import type { RuleBasedRecommendation } from '@/components/gcp/gcpHelpers'
import GcpCopyButton from '@/components/gcp/GcpCopyButton'

interface GcpRuleBasedCalloutProps {
  recommendation: RuleBasedRecommendation
}

export default function GcpRuleBasedCallout({ recommendation }: GcpRuleBasedCalloutProps) {
  const title =
    recommendation.service ||
    recommendation.instance ||
    recommendation.bucket ||
    recommendation.resource ||
    'Finding'

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950">
      <p className="font-medium">
        Rule-based finding — {title}
      </p>
      {recommendation.current ? (
        <p className="mt-1">
          <span className="font-medium">Current:</span> {recommendation.current}
        </p>
      ) : null}
      {recommendation.suggested ? (
        <p className="mt-1">
          <span className="font-medium">Suggestion:</span> {recommendation.suggested}
        </p>
      ) : null}
      {recommendation.reason ? <p className="mt-1 text-amber-900">{recommendation.reason}</p> : null}
      {recommendation.estimated_savings ? (
        <p className="mt-1 text-amber-800">Est. savings: {recommendation.estimated_savings}</p>
      ) : null}
      {recommendation.implementation ? (
        <div className="mt-2">
          <div className="flex items-center justify-between gap-2">
            <span className="font-medium">Implementation commands</span>
            <GcpCopyButton text={recommendation.implementation} label="Copy" />
          </div>
          <pre className="mt-1 overflow-x-auto rounded bg-amber-100/60 p-2 text-xs text-amber-950 whitespace-pre-wrap">
            {recommendation.implementation}
          </pre>
        </div>
      ) : null}
    </div>
  )
}
